/**
 * Internal registry mapping chain IDs to Alchemy RPC base URLs.
 * This replaces the need for custom chain exports with embedded Alchemy URLs.
 *
 * Auto-generated by the ws-tools CLI — do not manually edit.
 */
export const ALCHEMY_RPC_MAPPING: Record<number, string> = {
  // ANIME networks
  6900: "https://anime-sepolia.g.alchemy.com/v2", // animeSepolia
  69000: "https://anime-mainnet.g.alchemy.com/v2", // animeMainnet

  // APECHAIN networks
  33139: "https://apechain-mainnet.g.alchemy.com/v2", // apechainMainnet
  33111: "https://apechain-curtis.g.alchemy.com/v2", // apechainCurtis

  // ARB networks
  421614: "https://arb-sepolia.g.alchemy.com/v2", // arbSepolia
  42161: "https://arb-mainnet.g.alchemy.com/v2", // arbMainnet

  // ARC networks
  5042002: "https://arc-testnet.g.alchemy.com/v2", // arcTestnet

  // BASE networks
  8453: "https://base-mainnet.g.alchemy.com/v2", // baseMainnet
  84532: "https://base-sepolia.g.alchemy.com/v2", // baseSepolia

  // BERACHAIN networks
  80094: "https://berachain-mainnet.g.alchemy.com/v2", // berachainMainnet
  80069: "https://berachain-bepolia.g.alchemy.com/v2", // berachainBepolia

  // BNB networks
  97: "https://bnb-testnet.g.alchemy.com/v2", // bnbTestnet
  56: "https://bnb-mainnet.g.alchemy.com/v2", // bnbMainnet

  // CELO networks
  11142220: "https://celo-sepolia.g.alchemy.com/v2", // celoSepolia
  42220: "https://celo-mainnet.g.alchemy.com/v2", // celoMainnet

  // CLANKERMON networks
  510525: "https://clankermon-mainnet.g.alchemy.com/v2", // clankermonMainnet

  // ETH networks
  1: "https://eth-mainnet.g.alchemy.com/v2", // ethMainnet
  11155111: "https://eth-sepolia.g.alchemy.com/v2", // ethSepolia
  560048: "https://eth-hoodi.g.alchemy.com/v2", // ethHoodi

  // FRAX networks
  252: "https://frax-mainnet.g.alchemy.com/v2", // fraxMainnet

  // GENSYN networks
  685689: "https://gensyn-mainnet.g.alchemy.com/v2", // gensynMainnet
  685685: "https://gensyn-testnet.g.alchemy.com/v2", // gensynTestnet

  // HYPERLIQUID networks
  998: "https://hyperliquid-testnet.g.alchemy.com/v2", // hyperliquidTestnet
  999: "https://hyperliquid-mainnet.g.alchemy.com/v2", // hyperliquidMainnet

  // INK networks
  57073: "https://ink-mainnet.g.alchemy.com/v2", // inkMainnet
  763373: "https://ink-sepolia.g.alchemy.com/v2", // inkSepolia

  // KATANA networks
  737373: "https://katana-bokuto.g.alchemy.com/v2", // katanaBokuto
  747474: "https://katana-mainnet.g.alchemy.com/v2", // katanaMainnet

  // MATIC networks
  80002: "https://polygon-amoy.g.alchemy.com/v2", // maticAmoy
  137: "https://polygon-mainnet.g.alchemy.com/v2", // maticMainnet

  // MEGAETH networks
  4326: "https://megaeth-mainnet.g.alchemy.com/v2", // megaethMainnet
  6343: "https://megaeth-testnet.g.alchemy.com/v2", // megaethTestnet

  // MONAD networks
  10143: "https://monad-testnet.g.alchemy.com/v2", // monadTestnet
  143: "https://monad-mainnet.g.alchemy.com/v2", // monadMainnet

  // MYTHOS networks
  42018: "https://mythos-mainnet.g.alchemy.com/v2", // mythosMainnet

  // OPBNB networks
  5611: "https://opbnb-testnet.g.alchemy.com/v2", // opbnbTestnet
  204: "https://opbnb-mainnet.g.alchemy.com/v2", // opbnbMainnet

  // OPT networks
  10: "https://opt-mainnet.g.alchemy.com/v2", // optMainnet
  11155420: "https://opt-sepolia.g.alchemy.com/v2", // optSepolia

  // PLASMA networks
  9746: "https://plasma-testnet.g.alchemy.com/v2", // plasmaTestnet
  9745: "https://plasma-mainnet.g.alchemy.com/v2", // plasmaMainnet

  // RISE networks
  4153: "https://rise-mainnet.g.alchemy.com/v2", // riseMainnet
  11155931: "https://rise-testnet.g.alchemy.com/v2", // riseTestnet

  // ROBINHOOD networks
  46630: "https://robinhood-testnet.g.alchemy.com/v2", // robinhoodTestnet
  4663: "https://robinhood-mainnet.g.alchemy.com/v2", // robinhoodMainnet

  // SHAPE networks
  11011: "https://shape-sepolia.g.alchemy.com/v2", // shapeSepolia
  360: "https://shape-mainnet.g.alchemy.com/v2", // shapeMainnet

  // SONEIUM networks
  1946: "https://soneium-minato.g.alchemy.com/v2", // soneiumMinato
  1868: "https://soneium-mainnet.g.alchemy.com/v2", // soneiumMainnet

  // STABLE networks
  988: "https://stable-mainnet.g.alchemy.com/v2", // stableMainnet
  2201: "https://stable-testnet.g.alchemy.com/v2", // stableTestnet

  // STORY networks
  1514: "https://story-mainnet.g.alchemy.com/v2", // storyMainnet
  1315: "https://story-aeneid.g.alchemy.com/v2", // storyAeneid

  // UNICHAIN networks
  1301: "https://unichain-sepolia.g.alchemy.com/v2", // unichainSepolia
  130: "https://unichain-mainnet.g.alchemy.com/v2", // unichainMainnet

  // WORLDCHAIN networks
  4801: "https://worldchain-sepolia.g.alchemy.com/v2", // worldchainSepolia
  480: "https://worldchain-mainnet.g.alchemy.com/v2", // worldchainMainnet

  // WORLDMOBILECHAIN networks
  869: "https://worldmobilechain-mainnet.g.alchemy.com/v2", // worldmobilechainMainnet

  // XLAYER networks
  1952: "https://xlayer-testnet.g.alchemy.com/v2", // xlayerTestnet
  196: "https://xlayer-mainnet.g.alchemy.com/v2", // xlayerMainnet

  // ZORA networks
  7777777: "https://zora-mainnet.g.alchemy.com/v2", // zoraMainnet
  999999999: "https://zora-sepolia.g.alchemy.com/v2", // zoraSepolia
};

/**
 * Gets the Alchemy RPC base URL for a given chain ID.
 *
 * @param {number} chainId The chain ID to lookup
 * @returns {string | undefined} The Alchemy RPC base URL or undefined if not supported
 *
 * @example
 * ```ts
 * const rpcUrl = getAlchemyRpcUrl(1); // "https://eth-mainnet.g.alchemy.com/v2"
 * ```
 */
export function getAlchemyRpcUrl(chainId: number): string | undefined {
  return ALCHEMY_RPC_MAPPING[chainId];
}

/**
 * Checks if a chain ID is supported by the Alchemy RPC registry.
 *
 * @param {number} chainId The chain ID to check
 * @returns {boolean} True if the chain is supported, false otherwise
 */
export function isChainSupported(chainId: number): boolean {
  return chainId in ALCHEMY_RPC_MAPPING;
}

/**
 * Gets all supported chain IDs from the registry.
 *
 * @returns {number[]} Array of supported chain IDs
 */
export function getSupportedChainIds(): number[] {
  return Object.keys(ALCHEMY_RPC_MAPPING).map(Number);
}
